import { render, staticRenderFns } from "./TournamentAwards.vue?vue&type=template&id=7926c8b0&scoped=true"
import script from "./TournamentAwards.vue?vue&type=script&lang=js"
export * from "./TournamentAwards.vue?vue&type=script&lang=js"
import style0 from "./TournamentAwards.vue?vue&type=style&index=0&id=7926c8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7926c8b0",
  null
  
)

export default component.exports